export const RECEIVE_SESSION_ID = 'RECEIVE_SESSION_ID'
export const RECEIVE_LOGIN_STATE = 'RECEIVE_LOGIN_STATE'
